import {hpcAttrs} from '@github-ui/hpc'
import {useRoutePayload} from '@github-ui/react-core/use-route-payload'
import {testIdProps} from '@github-ui/test-id-props'
import type {ShowModelPayload} from '../../../types'
import {VerifiedHTMLDiv} from '@github-ui/safe-html/VerifiedHTML'

export function Evaluation() {
  const {modelEvaluation} = useRoutePayload<ShowModelPayload>()

  return (
    <>
      {modelEvaluation && (
        <VerifiedHTMLDiv
          {...hpcAttrs()}
          html={modelEvaluation}
          className="tmp-p-3"
          {...testIdProps('evaluation-content')}
        />
      )}
    </>
  )
}
